import { FetchResult, NormalizedCacheObject } from 'apollo-boost';

import {
    addSmartFilters,
    deleteSmartFilters,
    updateSmartFilters
} from '../../graphql/mutations/grid/groups';
import {
    AddSmartFilters,
    DeleteSmartFilters,
    GdAddSmartFiltersInput,
    GdDeleteSmartFilterInput,
    GdUpdateSmartFiltersInput,
    UpdateSmartFilters
} from '../../typings/graphql-grid';
import { DNAApolloClient } from '../DNAApolloClient/DNAApolloClient';

export class SmartFiltersMutationExecutor {
    constructor(private client: DNAApolloClient<NormalizedCacheObject>) {}

    public addSmartFilters(
        input: GdAddSmartFiltersInput,
        login: string
    ): Promise<FetchResult<AddSmartFilters>> {
        return this.client.awaitMutate<AddSmartFilters>({
            mutation: addSmartFilters,
            variables: {
                input,
                login
            },
            login
        });
    }

    public deleteSmartFilters(
        input: GdDeleteSmartFilterInput,
        login: string
    ): Promise<FetchResult<DeleteSmartFilters>> {
        return this.client.awaitMutate<DeleteSmartFilters>({
            mutation: deleteSmartFilters,
            variables: {
                input,
                login
            },
            login
        });
    }

    public updateSmartFilters(
        input: GdUpdateSmartFiltersInput,
        login: string
    ): Promise<FetchResult<UpdateSmartFilters>> {
        return this.client.awaitMutate<UpdateSmartFilters>({
            mutation: updateSmartFilters,
            variables: {
                input,
                login
            },
            login
        });
    }
}
